module.exports = __webpack_public_path__ + "img/float_video.6f25ebdf.png";